import { type ProductSpecCategory } from '@/gql/graphql';

export const FLOW_SETTINGS_PATH = '/companySettings/sales-payments/flow';
export const GLOW_SETTINGS_PATH = '/companySettings/sales-payments/glow';

const GLOW_CATEGORIES: ReadonlyArray<ProductSpecCategory> = [
  'SOLAR_PANEL',
  'INVERTER',
  'BATTERY',
];

export const estimateSettingsPathForCategory = (
  category: ProductSpecCategory
): string =>
  GLOW_CATEGORIES.includes(category) ? GLOW_SETTINGS_PATH : FLOW_SETTINGS_PATH;
